import Xarrow from "react-xarrows";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

function ManualDef1({ setTutorial }) {
  const renderTrigger = useArrowSync();

  const handleOnClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("group_function") && (
        <div className={`${styles["container"]} ${styles["container-1a"]} ${styles["overlay"]}`}>
          <div
            id="tutorial-text-1a"
            className={`${styles["container__text"]} ${styles["container__text-1a"]}`}>
            <p>This sidebar lists all functions within your current model.</p>
            <p>
              Click the <b>Add Function</b> button to create a new one.
            </p>
          </div>

          <Xarrow
            key={`arrow-1-${renderTrigger}`}
            start="tutorial-text-1a"
            end="group_function"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      {document.getElementById("header_function") && (
        <div className={`${styles["container"]} ${styles["container-1b"]} ${styles["overlay"]}`}>
          <div
            id="tutorial-text-1b"
            className={`${styles["container__text"]} ${styles["container__text-1b"]}`}>
            <p>This is your active function workspace</p>
            <p>Click the header to expand or collapse the panel</p>
          </div>

          <Xarrow
            key={`arrow-2-${renderTrigger}`}
            start="tutorial-text-1b"
            end="header_function"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-1"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleOnClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Welcome to Tomato 🍅. In this quick tutorial, you'll learn how to build a simple model
              and generate tests. Models are organized into functions, which contain your parameters
              and logic. Let's get started!
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Got it!" onClick={handleOnClose} />
          </div>
        </div>
      </div>
    </>
  );
}

export default ManualDef1;
